export default {
  heroEyebrow: "Basetao Spreadsheet Resource Hub",
  heroH1: "Basetao Spreadsheet — Find Products, Sellers & Smarter Shopping Resources",
  heroText:
    "Discover Basetao Spreadsheet resources, product research guides, seller information, QC tips, shipping guides and practical resources designed to make Chinese shopping easier to research.",
  heroCta1: "Basetao Spreadsheet",
  heroCta2: "Buy It Now",
  heroTrust: "Independent resource · Practical research · Updated guides",

  categoriesEyebrow: "Shop by Category",
  categoriesTitle: "Browse Products by Category",
  categoriesText:
    "Pick a category below to explore products, sellers and spreadsheet finds on the main site. Every link opens in a new tab.",
  dropdownLabel: "Select a category",
  dropdownPlaceholder: "Choose a category…",
  dropdownGo: "Open",

  aboutEyebrow: "What Is It",
  aboutTitle: "What Is a Basetao Spreadsheet?",
  aboutP1:
    "A Basetao Spreadsheet is a community-shared list or table of products, links, seller notes and quality-check (QC) observations used by shoppers who order through the Basetao shopping agent. These spreadsheets help you compare finds, spot reliable sellers and research items before you commit to a purchase.",
  aboutP2:
    "Because a spreadsheet organizes hundreds of product links in one place, it turns a slow, scattered search into a faster, more structured way to research clothing, sneakers, accessories and more.",
  aboutP3:
    "Always treat a spreadsheet as a starting point, not a guarantee. Check the current price, seller rating and shipping terms yourself before ordering.",

  guidesEyebrow: "Guides & Articles",
  guidesTitle: "Read Our Original Guides",
  guidesText:
    "Independent, original articles to help you research products, understand QC and make smarter decisions.",
  guide1Title: "Basetao Spreadsheet: Complete Beginner Guide",
  guide1Text:
    "What a Basetao Spreadsheet is, how it works, popular categories, QC tips and shipping basics — everything a beginner needs to know.",
  guide2Title: "Product Categories Overview",
  guide2Text:
    "A quick tour of the main product categories you will find, from sneakers and hoodies to bags and accessories.",
  guide3Title: "How to Read QC Photos",
  guide3Text:
    "Understand QC photos, measurements and the warning signs to look for before you approve an item.",
  guide4Title: "Shipping Basics Explained",
  guide4Text:
    "How shipping cost is estimated, what affects the price, and the factors to compare between lines.",
  readMore: "Read article",

  howEyebrow: "How It Works",
  howTitle: "Research Smarter in Four Steps",
  step1Title: "Find",
  step1Text: "Discover products, sellers and spreadsheet resources in one place.",
  step2Title: "Research",
  step2Text: "Compare product, seller and quality-check information.",
  step3Title: "Verify",
  step3Text: "Check the current price, shipping and policies yourself.",
  step4Title: "Decide",
  step4Text: "Order with better information and fewer surprises.",

  faqEyebrow: "FAQ",
  faqTitle: "Frequently Asked Questions",
  faq1Q: "What is a Basetao Spreadsheet?",
  faq1A:
    "It is a community-shared list or table of product links, seller notes and QC observations used by shoppers who order through the Basetao shopping agent.",
  faq2Q: "Is this the official Basetao website?",
  faq2A:
    "No. This is an independent informational website. We are not affiliated with or endorsed by Basetao.",
  faq3Q: "How do I find products on the main site?",
  faq3A:
    "Use the category dropdown or category buttons on this page. Each link opens the matching category on the main site in a new tab.",
  faq4Q: "How much does Basetao shipping cost?",
  faq4A:
    "Shipping cost depends on destination, weight, dimensions and the shipping method. Always check the current rates on the main site before ordering.",
  faq5Q: "Are the products guaranteed?",
  faq5A:
    "No. A spreadsheet or product link does not guarantee authenticity, quality or delivery. Always research sellers and QC information first.",

  finalCtaTitle: "Start With Basetao Spreadsheet",
  finalCtaText:
    "Explore product resources, research guides, QC information and shipping guides in one organized hub.",
  finalCtaButton: "Explore Basetao Spreadsheet",
};